// store/modules/auth/state.js
export default {
  bootstrapped: false,
  passthrough: '',
  token: null,
  authInitialized: false,
  roles: [],
  userProfile: null,
  primaryRole: null,
  userToken: null,
  userInfo: null,
  businessUsers: [],
  isLogout: false,
  demoMode: false,
  language: '',
  solution: 1,
  isLogging: false,
  showLog: false,
  log: [
    {
      id: 0,
      component: 'main',
      method: 'init',
      text: 'starting log'
    }
  ],
  systemLog: [
    {
      id: 1000,
      component: 'main',
      method: 'init',
      text: 'starting system log'
    }
  ],
  languages: [
    {
      name: '',
      value: ''
    },
    {
      name: 'English',
      value: 'en'
    },
    {
      name: 'Croatian',
      value: 'hr'
    },
    {
      name: 'Czech',
      value: 'cs'
    },
    {
      name: 'Danish',
      value: 'da'
    },
    {
      name: 'Dutch',
      value: 'nl'
    },
    {
      name: 'Finnish',
      value: 'fi'
    },
    {
      name: 'French',
      value: 'fr'
    },
    {
      name: 'German',
      value: 'de'
    },
    {
      name: 'Greek',
      value: 'el'
    },
    {
      name: 'Italian',
      value: 'it'
    },
    {
      name: 'Lithuanian',
      value: 'lt'
    },
    {
      name: 'Norwegian',
      value: 'no'
    },
    {
      name: 'Polish',
      value: 'pl'
    },
    {
      name: 'Portuguese',
      value: 'pt'
    },
    {
      name: 'Slovak',
      value: 'sk'
    },
    {
      name: 'Slovene',
      value: 'sl'
    },
    {
      name: 'Spanish',
      value: 'es'
    },
    {
      name: 'Swedish',
      value: 'sv'
    }
  ],
  notificationToken: null,
  mahleDiagnosticLicenseStatus: null,
  mahleCoinBalance: null,
  mahleApiErrorMsg: null,
  userIsMahle: null,
  termAndConditionsUIMessage: '',
  configuration: [],
  isRagOnly: false,
  showRag: false,
  fullUserData: null,
  chatAs: null
}
